import React from 'react';
import './styles.css';
import Project from './Project/';
import Shake from 'shake.js';
import Draggable from 'react-draggable';
import projectsList from '../../projects'
import { withRouter } from "react-router-dom";

class Projects extends React.Component{

    state = {
        projectsWidth: 1600,
        prevPath: '',
        active: '',
        translateX: 0,
        projectsListWidth: [],
        showHitBubble: true,
        projectsSize: [],
        dragging: false,
        isMobile: false,
        touchMouvement: 0,
        lastDir: null,
        projectsImgs: [],
        destroyImgTO: null
    };

    handleStart = (event, ui) => {
        this.getMaxBoundLeft();
        this.setState({dragging: true});
    };

    handleDrag = (event, ui) => {
        const removeActiveClass = () => {
            const $projects = document.getElementsByClassName('project');
            for(let i=0; i < $projects.length; i++){
                $projects[i].classList.remove('active');
            }
        };

        if(ui.deltaX>0){
            this.setState({lastDir: 'prev'});
            if(this.state.lastDir !== 'prev'){
                this.setState({touchMouvement: 0});
                console.log('reset');
            }else{
                this.setState({touchMouvement: this.state.touchMouvement+1});
            }
            this.scrollAnimation(true, 'prev', event.movementX);
            removeActiveClass();
        }else{
            this.setState({lastDir: 'next'});
            if(this.state.lastDir !== 'next'){
                this.setState({touchMouvement: 0});
                console.log('reset');
            }else{
                this.setState({touchMouvement: this.state.touchMouvement+1});
            }
            this.scrollAnimation(true, 'next', event.movementX);
            removeActiveClass();
        }
    };

    scrollAnimation = (status, direction = false, deg) => {
        let posDeg = 0;
        let rotateZ = 0;
        if(deg){
            posDeg = Math.abs(deg)*2;
                posDeg >= 40 ?  posDeg = 40 : posDeg;
            rotateZ = Math.abs(deg)/5;
                rotateZ >= 4 ?  rotateZ = 4 : rotateZ;
        }else{
            posDeg = Math.abs(this.state.touchMouvement)*2;
                posDeg >= 40 ?  posDeg = 40 : posDeg;
            rotateZ = Math.abs(this.state.touchMouvement)/5;
                rotateZ >= 4 ?  rotateZ = 4 : rotateZ;
        }



        let $projects = document.getElementsByClassName('js-project');
        if(status){
            for(let i=0; i < $projects.length ; i++){
                if(Math.abs(deg)>2){
                    this.refs.projectsDraggableArea.classList.add('projects-not-dragging');
                }else{
                    this.refs.projectsDraggableArea.classList.remove('projects-not-dragging');
                }
                if(direction === 'next'){
                    $projects[i].style.transform = `skew(-${posDeg}deg)`;
                    this.refs.projectsDraggableArea.classList.remove('dir-left');
                    this.refs.projectsDraggableArea.classList.add('dir-right');
                    this.refs.projectsDragAreaWrapper.style.transform = `scale(0.8) rotateZ(-${rotateZ}deg)`
                }else if(direction === 'prev'){
                    $projects[i].style.transform = `skew(${posDeg}deg)`;
                    this.refs.projectsDraggableArea.classList.remove('dir-right');
                    this.refs.projectsDraggableArea.classList.add('dir-left');
                    this.refs.projectsDragAreaWrapper.style.transform = `scale(0.8) rotateZ(${rotateZ}deg)`
                }
            }
        }else{
            for(let i=0; i < $projects.length ; i++) {
                $projects[i].style.transform = 'skew(0deg)';
            }
            this.refs.projectsDragAreaWrapper.style.transform = 'scale(1) rotateZ(0deg)'
        }
    };

    handleStop = (event, ui) => {
        this.scrollAnimation(false);
        this.sendDragPosition(ui.x);
        this.setState({dragging: false});
        this.setState({touchMouvement: 0});
        console.log('full reset');
    };

    getMaxBoundLeft = () => {
        let $projects = document.getElementsByClassName('js-project');
        let projectSize = [];
        for(let n=0; n < $projects.length ; n++){
            switch(true){
                case n === 0:
                    projectSize.push(-Math.abs($projects[n].offsetWidth));
                    break;
                default:
                    projectSize.push(-Math.abs($projects[n].offsetWidth + $projects[n-1].offsetWidth));
                    break;
            }
        }
        this.setState({projectsWidth: projectSize[projectSize.length-1]+400});
        this.setState({projectsListWidth: projectSize});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.setState({ prevPath: this.props.location });
        }
    }

    componentWillUnmount(){
        this.refs.projects.classList.remove('show');
        window.removeEventListener('resize', this.getIfMobile);
        window.removeEventListener('shake', this.shakeEvent, false);
    }
    componentDidMount(){
        let $projects = document.getElementsByClassName('js-project');
        let projectsSize = [];
        let size = 0;
        for(let n=0; n < $projects.length ; n++){
            if(n !== 0){
                size = $projects[n].offsetWidth + $projects[n-1].offsetWidth;
                projectsSize.push(-Math.abs(size));
            }else{
                projectsSize.push(-Math.abs($projects[n].offsetWidth));
            }
        }
        this.setState({projectsSize});
        this.refs.projects.classList.add('show');
        if(this.props.history.action === 'POP'){
            this.refs.projects.classList.add('init-projects-end');
        }
        this.getIfMobile();
        window.addEventListener('resize', this.getIfMobile);
        let myShakeEvent = new Shake({
            threshold: 7,
            timeout: 100
        });
        myShakeEvent.start();
        window.addEventListener('shake', this.shakeEvent, false);
        this.getProjectsImg();
    }

    getProjectsImg = () => {
        let projectsImgs = projectsList.map((project, index) => {
            return project.images;
        });
        let array = [];
        for(let i = 0; i<projectsImgs.length; i++){
            array.push(...projectsImgs[i]);
        }
        this.setState({projectsImgs: array});
    }

    shakeEvent= () => {
        const removeAllProjectImg = () => {
            let elements = document.getElementsByClassName('img-wrapper');
            while(elements.length > 0){
                elements[0].parentNode.removeChild(elements[0]);
            }
            this.setState({imgI: 0});
        }

        let numderDelay = 10;
        let numberIndex = 0;
        let newImg = this.img_create(this.state.projectsImgs[this.getRandomArbitrary(0,this.state.projectsImgs.length-1)], '', '');
        this.refs.imgWrapper.appendChild(newImg);

        this.setState({imgI: this.state.imgI+1});
        clearTimeout(this.state.destroyImgTO);
        let destroyImgTO = setTimeout(()=>{
            removeAllProjectImg();
        },1000);
        this.setState({destroyImgTO});
    }

    getRandomArbitrary = (min, max) => {
        return Math.round(Math.random() * (max - min) + min);
    }

    img_create = (src, alt, title) => {
        let wrapper = document.createElement('div');
        wrapper.className = 'img-wrapper';
        wrapper.style.display = 'block';
        let img = document.createElement('img');
        img.src = src;
        if ( alt != null ) img.alt = alt;
        if ( title != null ) img.title = title;
        wrapper.appendChild(img);
        wrapper.style.top = `${this.getRandomArbitrary(-40,40)}px`;
        wrapper.style.left = `${this.getRandomArbitrary(-40,40)}px`;
        return wrapper;
    }

    componentWillMount(){
        document.body.style.overflow = 'hidden';
        if(this.props.dragPosition){
            this.setState({translateX: this.props.dragPosition});
        }
    }

    sendDragPosition(pos){
        this.props.getDragPosition(pos);
    }

    getIfElementHit = (status) =>{
        this.setState({showHitBubble: status});
    }
    

    // setNotHolding = () => {
    //     let timeout = null;
    //     console.log(this.refs.projectsDraggableArea);
    //     if(!this.props.hold && this.state.dragging){
    //         timeout = setTimeout(()=>{
    //             this.refs.projects.classList.add('project-not-holding');
    //         },500)
    //     }else{
    //         this.refs.projects.classList.remove('project-not-holding');
    //     }
    //     clearInterval(timeout);
    // }

    getIfMobile = () => {
        if(document.documentElement.clientWidth<480){
            this.setState({isMobile: true});
        }else{
            this.setState({isMobile: false});
        }
    }

    render(){
        const projects = Object
            .keys(projectsList)
            .map(key => {
                if(key === this.props.activeProject){
                    return(
                        <Project projectsSize={this.state.projectsSize} isMobileSize={this.state.isMobile}
                                 showHitBubble={this.state.showHitBubble} getIfElementHit={this.getIfElementHit} active={true} className={this.props.activeProject ? 'active' : ''} holdEnd={this.props.holdEnd} cursorEvent={this.props.cursorEvent} key={key} details={projectsList[key]}/>
                    )
                }else{
                    return(
                        <Project projectsSize={this.state.projectsSize} isMobileSize={this.state.isMobile} showHitBubble={this.state.showHitBubble} getIfElementHit={this.getIfElementHit} active={false} holdEnd={this.props.holdEnd} cursorEvent={this.props.cursorEvent} key={key} details={projectsList[key]}/>
                    )
                }
            });

        return(
            <div className={`projects ${this.props.hold ? 'project-hold' : ''}`} ref="projects">
                {/*<h3>Creative front-end developer based in France<br/>obessed with UI animations</h3>*/}
                <div className="container">
                    <div className="img-mobile-wrapper" ref="imgWrapper"/>
                    {!this.state.isMobile ?
                        <Draggable
                            axis="x"
                            handle=".projects-drag-area"
                            grid={[75, 75]}
                            defaultPosition={{x: this.state.translateX, y: 0}}
                            bounds={{left: this.state.projectsSize[this.state.projectsSize.length-1], top: 0, right: 0, bottom: 0}}
                            onStart={this.handleStart}
                            onDrag={this.handleDrag}
                            onStop={this.handleStop}>
                            <div className="projects-drag-area" ref="projectsDraggableArea">
                                <div className="projects-drag-area-wrapper" ref="projectsDragAreaWrapper">
                                    {projects}
                                </div>
                            </div>
                        </Draggable>
                        :
                        <div className="mobile-projects-wrapper">
                            {projects}
                        </div>
                    }

                </div>
                <div className="fill-scroll-bottom scrolling" ref="fillScrollBottom">
                    <div className="fill-scroll-bottom-bg"/>
                    <div className="fill-scroll-bottom-inertia"/>
                </div>
            </div>
        )
    }
}
export default withRouter(Projects);


// WEBPACK FOOTER //
// ./src/components/Projects/index.js